import type { ChatDocumentDTO } from '@shared/schemas/chat';
import type {
  DocumentGenerationKindDTO,
  DocumentGenerationResultDTO,
} from '@shared/schemas/document-generation';
import {
  DOCX_MIME_TYPE,
  PDF_MIME_TYPE,
  PPTX_MIME_TYPE,
  XLSX_MIME_TYPE,
} from './components/document-viewer/document-viewer-registry';

export const CODEGEN_DOCUMENT_ID_PREFIX = 'docgen:';

const KIND_MEDIA_TYPES: Record<DocumentGenerationKindDTO, string> = {
  docx: DOCX_MIME_TYPE,
  pdf: PDF_MIME_TYPE,
  pptx: PPTX_MIME_TYPE,
  xlsx: XLSX_MIME_TYPE,
};

/**
 * Classeurs et présentations de la voie script : les lecteurs XLSX/PPTX interrogent l'API
 * par identifiant de document indexé, qu'un `docgen:<uuid>` n'est pas.
 */
export function isPreviewUnavailableMediaType(mediaType: string | null | undefined) {
  return mediaType === XLSX_MIME_TYPE || mediaType === PPTX_MIME_TYPE;
}

export function isCodegenChatDocument(document: ChatDocumentDTO) {
  return document.documentId.startsWith(CODEGEN_DOCUMENT_ID_PREFIX);
}

/** Identifiant de génération porté par un document `docgen:<generationId>`, ou null. */
export function parseCodegenGenerationId(document: Pick<ChatDocumentDTO, 'documentId'>) {
  return document.documentId.startsWith(CODEGEN_DOCUMENT_ID_PREFIX)
    ? document.documentId.slice(CODEGEN_DOCUMENT_ID_PREFIX.length)
    : null;
}

export function buildCodegenChatDocument(input: {
  result: DocumentGenerationResultDTO;
  title: string;
}): ChatDocumentDTO {
  return {
    content: '',
    documentId: `${CODEGEN_DOCUMENT_ID_PREFIX}${input.result.generationId}`,
    filename: input.result.filename,
    kind: 'attachment',
    mediaType: input.result.contentType,
    sourceUrl: input.result.downloadUrl,
    status: 'ready',
    summary: null,
    title: input.title,
  };
}

/**
 * Document « canvas » du moteur blocks : aucun fichier source, l'aperçu est
 * chargé par le canvas à partir de l'identifiant de génération.
 */
export function buildGenerationCanvasDocument(input: {
  generationId: string;
  kind: DocumentGenerationKindDTO | null;
  title: string;
}): ChatDocumentDTO {
  return {
    content: '',
    documentId: `${CODEGEN_DOCUMENT_ID_PREFIX}${input.generationId}`,
    filename: null,
    kind: 'attachment',
    mediaType: input.kind ? KIND_MEDIA_TYPES[input.kind] : null,
    sourceUrl: null,
    status: 'ready',
    summary: null,
    title: input.title,
  };
}
